export default __webpack_public_path__ + "static/media/85.7ecd30b3.jpeg";